import { render, staticRenderFns } from "./BranchOffice.vue?vue&type=template&id=cb15df2c&"
import script from "./BranchOffice.vue?vue&type=script&lang=js&"
export * from "./BranchOffice.vue?vue&type=script&lang=js&"
import style0 from "./BranchOffice.vue?vue&type=style&index=0&id=cb15df2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports